import { memo, useCallback } from "react";
import PropTypes from "prop-types";
import "./BackButton.scss";
import { FormattedMessage } from "react-intl";
import { sendTagOnBackButton } from "app/utils/analytics";
import { useLocation, useNavigate } from "react-router-dom";
import { ButtonLink } from "app/components/ui/ButtonLink/ButtonLink";
import { Button } from "app/components/ui/Button/Button";
import { ArrowLeftIcon } from "app/icons/navigation";
import classNames from "classnames";

const BackButtonComponent = ({ to, className, label, forceBrowserBack, onClick }) => {
	const { pathname } = useLocation();
	const navigate = useNavigate();

	const handleClick = useCallback(() => {
		sendTagOnBackButton(pathname);
		onClick();
	}, [pathname, onClick]);

	const backHistory = useCallback(() => {
		if (typeof window !== "undefined") {
			onClick();
			navigate(-1);
		}
	}, [onClick, navigate]);

	if (forceBrowserBack) {
		return (
			<Button
				variant="borderless"
				size={label ? "lg" : "icon-lg"}
				startIcon={<ArrowLeftIcon size={20} />}
				className={classNames("back-button", className)}
				onClick={backHistory}
				data-testid="back-button"
			>
				{label && (
					<div className="back-button__label">
						<FormattedMessage id={label} />
					</div>
				)}
			</Button>
		);
	}

	return (
		<div className="back-button">
			<ButtonLink
				variant="borderless"
				size="lg"
				className={className}
				startIcon={<ArrowLeftIcon size={20} />}
				to={{ ...to }}
				replace
				onClick={handleClick}
				data-testid="back-button"
			>
				{label && (
					<div className="back-button__label">
						<FormattedMessage id={label} />
					</div>
				)}
			</ButtonLink>
		</div>
	);
};

BackButtonComponent.propTypes = {
	to: PropTypes.object,
	className: PropTypes.string,
	onClick: PropTypes.func,
	label: PropTypes.string,
	forceBrowserBack: PropTypes.bool,
};

BackButtonComponent.defaultProps = {
	onClick: () => {},
	to: {},
};

export const BackButton = memo(BackButtonComponent);
